// extracted by mini-css-extract-plugin
export default {"AuthSidePresentation":"AuthSidePresentation_AuthSidePresentation__xwwM5","Footer":"AuthSidePresentation_Footer__wJwMU"};